import { Controller } from "@hotwired/stimulus"

// "Default topics" editor on the meeting-template form. Renders a list
// of topic rows; the "Add topic" button clones a hidden blank row with
// a fresh index so the user can add as many as they like. Rows are
// submitted as topic_lines[<index>][title|description|default_kind];
// the controller replace-saves them on the template.
export default class extends Controller {
  static targets = ["list", "template", "row"]

  connect() {
    // Next index continues past the server-rendered rows so new rows
    // never collide with existing names.
    this._nextIndex = this.rowTargets.length
  }

  addRow(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this._nextIndex)
    this._nextIndex += 1
    this.listTarget.insertAdjacentHTML("beforeend", html)
    // Focus the title input of the row we just added.
    const rows = this.listTarget.querySelectorAll("[data-template-topics-target='row']")
    const last = rows[rows.length - 1]
    last?.querySelector("input[type='text']")?.focus()
  }

  // Remove a row (the × button). Blank rows are ignored server-side, so
  // clearing the inputs is enough, but removing keeps the UI tidy.
  removeRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-template-topics-target='row']")
    row?.remove()
  }
}
